// @flow

import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import ru from 'react-intl/locale-data/ru';
import 'normalize.css/normalize.css';

import App from './components/App';
import intlData from './intl';
import './index.css';

addLocaleData([...en, ...ru]);
const defaultLocale = 'ru';

ReactDOM.render(
  <IntlProvider
    locale={defaultLocale}
    messages={intlData[defaultLocale]}
  >
    <App />
  </IntlProvider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js